/* eslint-disable no-undef */

import {getSetting} from '@/utils/settings' ;

function responseCodeOk (code) {
	if (!code) {
		return true;
	}

	return parseInt(code) < 300 && parseInt(code) >= 200;
}

export async function postData ({data, endpoint, auth = null, noResponse = false}) {
	const url = getSetting('REACT_APP_BASE_URL') + endpoint;
	try {
		const response = await fetch(url, {
			method: 'post',
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': 'en-GB',
				...(auth? {'X-API-KEY': auth}: {})
			}
		});

		if (response.ok && noResponse) {
			return { error: false };
		}

		const json = await response.json();

		if (!response.ok || json.response.code >= 300) {
			return {
				error: true,
				message: json.status && json.title
					? `${json.status}: ${json.title}`
					: json.response.error || "Something went wrong with the server!"
			};
		}

		if (json && !responseCodeOk(json.contentResponse?.code)) {
			return {error: true, message: json.contentResponse.error};
		}

		return {error: false, content: json?.content || {}};

	} catch (err) {
		return {error: true, message: err.message || 'Something whent wrong with the server!'};
	}
}

export async function getData ({auth, endpoint, signal}) {
	const version = (endpoint.includes('?') ? '&' : '?') + 'v=' + new Date().getTime();
	const url = getSetting('REACT_APP_BASE_URL') + endpoint + version;

	try {
		const response = await fetch(url, {
			method: 'get',
			cache: 'no-cache',
			headers: { 
				'Content-Type': 'application/json',
				'Accept-Language': 'en-GB',
				'X-API-KEY': auth
			},
			signal
		});

		if (!response.ok) {
			const json = await response.json();
			return {
				error: true,
				message: json.status && json.title
					? `${json.status}: ${json.title}`
					: "Something went wrong with the server!"
			};
		}

		if (response.status === 204) {
			return {error: false, content: []};
		}

		const json = await response.json();

		if (!responseCodeOk(json.contentResponse?.code)) {
			return {error: true, message: json.contentResponse.error};
		}

		return {error: false, content: json.content || json};

	} catch (err) {
		if (err.name === 'AbortError') {
			return {error: false};
		}

		return {error: true, message: err.message || 'Something whent wrong with the server!'};
	}
}

export async function deleteData ({auth, endpoint }) {
	const url = getSetting('REACT_APP_BASE_URL') + endpoint;

	try {
		const response = await fetch(url, {
			method: 'delete',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': 'en-GB',
				'X-API-KEY': auth
			}
		});

		if (!response.ok) {
			const json = await response.json();
			return {
				error: true,
				message: json.status && json.title
					? `${json.status}: ${json.title}`
					: "Something went wrong with the server!"
			};
		}

		const json = await response?.json?.();

		if (json && !responseCodeOk(json.contentResponse?.code)) {
			return {error: true, message: json.contentResponse.error};
		}

		return {error: false, content: json.content};

	} catch (err) {
		return {error: true, message: err.message || 'Something whent wrong with the server!'};
	}
}

export async function deleteDataNew ({auth, endpoint }) {
	const url = getSetting('REACT_APP_BASE_URL') + endpoint;

	try {
		const response = await fetch(url, {
			method: 'delete',
			cache: 'no-cache',
			headers: { 
				'Content-Type': 'application/json',
				'Accept-Language': 'en-GB',
				'X-API-KEY': auth
			}
		});

		if (!response.ok) {
			const json = await response.json();
			return {
				error: true,
				message: json.status && json.title
					? `${json.status}: ${json.title}`
					: "Something went wrong with the server!"
			};
		}

		return {error: false, content: null};

	} catch (err) {
		return {error: true, message: err.message || 'Something whent wrong with the server!'};
	}
}

export async function putData ({ endpoint, data, auth = null }) {
	const url = getSetting('REACT_APP_BASE_URL') + endpoint;

	try {
		const response = await fetch(url, {
			method: 'put',
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': 'en-GB',
				...(auth? {'X-API-KEY': auth}: {})
			}
		});

		const json = await response.json();

		if (!response.ok) {
			const json = await response.json();
			return {
				error: true,
				message: json.status && json.title
					? `${json.status}: ${json.title}`
					: "Something went wrong with the server!"
			};
		}

		if (json?.contentResponse && !responseCodeOk(json.contentResponse?.code)) {
			return {error: true, message: json.contentResponse.error};
		}

		return {error: false, content: json?.content || json};

	} catch (err) {
		return {error: true, message: err.message || 'Something whent wrong with the server!'};
	}
}

export async function postIngest ({data, endpoint, auth = null}) {
	const url = getSetting('REACT_APP_INGEST_BASE_URL') + endpoint;
	try {
		const response = await fetch(url, {
			method: 'post',
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Accept-Language': 'en-GB',
				...(auth? {'X-API-KEY': auth}: {})
			}
		});

		if (response.ok) {
			return { error: false };
		}

		const contentType = response.headers.get('content-type') || '';
		let message = `Request failed (${response.status})`;

		if (contentType.includes('application/json')) {
			const json = await response.json();
			message = json.message || json.title || json.status || message;
		} else {
			const text = await response.text();
			const match = /<message>([^<]+)<\/message>/.exec(text);
			if (match) {
				message = match[1];
			}
		}

		return {error: true, message};

	} catch (err) {
		return {error: true, message: err.message || 'Something whent wrong with the server!'};
	}
}